import { styled, Typography } from '@mui/material';
import { Cell } from 'react-table';
import { IInviteStatus } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

interface IStatusTypographyProps {
  cell: Cell;
}

const bgcolorStatusMap = new Map();

bgcolorStatusMap.set(IInviteStatus.INVITED, WsColors.Yellow100);
bgcolorStatusMap.set(IInviteStatus.ACTIVATED, WsColors.Green100);
bgcolorStatusMap.set(IInviteStatus.DEACTIVATED, WsColors.Red100);

const colorStatusMap = new Map();

colorStatusMap.set(IInviteStatus.INVITED, WsColors.Yellow500);
colorStatusMap.set(IInviteStatus.ACTIVATED, WsColors.Green500);
colorStatusMap.set(IInviteStatus.DEACTIVATED, WsColors.Red500);

const StatusTypography = styled(Typography)(({ cell }: IStatusTypographyProps) => ({
  backgroundColor: bgcolorStatusMap.get(cell.value),
  color: colorStatusMap.get(cell.value),
  padding: 4,
  width: 'fit-content',
  borderRadius: 4,
}));

export const ListHeader = [
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Role',
    accessor: 'role',
  },
  {
    Header: 'Download Access',
    accessor: 'downloadAccess',
  },
  {
    Header: 'Invite Status',
    accessor: 'status',
    Cell: (cell: Cell) => <StatusTypography cell={cell}>{cell.value}</StatusTypography>,
  },
];
